// src/components/CasosExito.jsx
import React from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/CasosExito.scss";

export const CasosExito = () => {
  // ✅ Adaptado a Pixbae Banquetes (testimonios tipo evento)
  const resenas = [
    {
      id: 1,
      nombre: "Mariana López",
      titulo: "Evento residencial • 35 personas",
      texto:
        "Contratamos Pixbae Banquetes para una reunión familiar. Las hamburguesas al carbón fueron un éxito total: sabor increíble, montaje impecable y atención súper profesional. Todo salió sin estrés.",
    },
    {
      id: 2,
      nombre: "Carlos Ramírez",
      titulo: "Evento empresarial • 60 personas",
      texto:
        "Necesitábamos un servicio puntual y bien organizado para una convivencia de empresa. El buffet de tacos al carbón estuvo espectacular y el equipo se encargó de todo. Nuestros invitados quedaron fascinados.",
    },
    {
      id: 3,
      nombre: "Andrea Torres",
      titulo: "Cumpleaños • 45 personas",
      texto:
        "Elegimos el buffet italiano y fue la mejor decisión. La comida se sirvió caliente, con excelente presentación y porciones perfectas. Se nota la experiencia del chef y el cuidado en cada detalle.",
    },
  ];

  return (
    <section className="casosExitoSection" id="casosExito">
      <div className="container casosExitoWrap">
        <Fade triggerOnce>
          <div className="casosHead text-center">
            <h2 className="casosTitle">Cientos de clientes nos recomiendan</h2>
            <p className="casosSubtitle">
              Conoce cómo <b>Pixbae Banquetes</b> ha hecho que eventos residenciales y
              empresariales se disfruten sin preocupaciones: sabor, montaje y atención profesional.
            </p>
          </div>
        </Fade>

        <div className="casosGrid">
          {resenas.map((r) => (
            <Fade key={r.id} triggerOnce>
              <article className="casoCard">
                <div className="casoTop">
                  <div className="bubbleIcon" aria-hidden="true">
                    <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
                  </div>
                  <div className="casoNameWrap">
                    <h3 className="casoName">{r.nombre}</h3>
                    <p className="casoMeta">{r.titulo}</p>
                  </div>
                </div>

                <p className="casoText">“{r.texto}”</p>

                <div className="stars" aria-label="Calificación 5 estrellas">
                  ★★★★★
                </div>
              </article>
            </Fade>
          ))}
        </div>

        <Fade triggerOnce>
          <div className="casosCta text-center">
            <p className="ctaText">
              🚀 Ellos ya disfrutaron su evento con Pixbae Banquetes. 🚀
            </p>
            <p className="ctaBig">
              <b>¡Tú también puedes hacerlo!</b>
            </p>
          </div>
        </Fade>
      </div>
    </section>
  );
};

export default CasosExito;
